// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"da72c2a7","555":"60eecbbb","893":"daae99d2"}[chunkId] + ".chunk.css";
};